import { render, staticRenderFns } from "./invoices-container.vue?vue&type=template&id=62738ec6"
import script from "./invoices-container.vue?vue&type=script&lang=ts"
export * from "./invoices-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports